module.exports = __webpack_public_path__ + "img/embed-typeform.a92b958.jpg";